import ticketUpdate from './ticketUpdate';

export default {
  namespaced: true,
  modules: {
    ticketUpdate
  }
};
